import { Injectable } from '@angular/core';
import { BaseService } from './base.service';
import { HttpClient } from '@angular/common/http';
import { lastValueFrom, map } from 'rxjs';
import { UserNeed } from '../interfaces/user-need';
import { GiftInter } from '../interfaces/gift-Inter';
import { ToastrService } from 'ngx-toastr';

@Injectable({
  providedIn: 'root',
})
export class UserNeedService extends BaseService<UserNeed | unknown> {
  constructor(http: HttpClient, toastr: ToastrService) {
    super(http, toastr);
  }

  // async gift_req(formData: GiftInter) {
  //   const result = this.post('UserNeed', formData).pipe(
  //     map((res) => {
  //       return res.success;
  //     })
  //   );
  //   return await lastValueFrom(result);
  // }

  async consultation_req(formData: GiftInter) {
    const result = this.post('UserNeed', formData).pipe(
      map((res) => {
        return res;
      })
    );
  
    return await lastValueFrom(result);
  }

    async sendOTP(
      phoneNumber: string,
      userWant: number,
      userNeedId: number,
      productId: number
    ) {
      const result = this.post('UserNeed/SendOTP', {
        phoneNumber,
        userWant,
        userNeedId,
        productId,
      }).pipe(
        map((res) => {
          return res;
        })
      );
    
      return await lastValueFrom(result);
    }

    async verifyOTP(
      phoneNumber: string,
      userWant: number,
      userNeedId: number,
      productId: number,
      otp: number
    ) {
      const result = this.post('UserNeed/VerifyOTP', {
        phoneNumber,
        userWant,
        userNeedId,
        productId,
        otp,
      }).pipe(
        map((res) => {
          return res;
        })
      );
    
      return await lastValueFrom(result);
    }
}